<div class="root">
  <ion-spinner
    name="lines"
    class="mu-spinner"
    [ngClass]="{
      'size-page': variant === 'page'
    }"
  ></ion-spinner>
  <ng-content></ng-content>
</div>
